import React, { PropsWithChildren } from 'react'
import { ColorValue, Pressable, PressableProps, StyleSheet, TextStyle, View, ViewStyle } from 'react-native'

import { Color, Spacing } from '../../style'
import Icon, { Name } from '../icon/icon'
import { Text } from '../typography'

import { IconSize } from '../icon'

import { screenOptions } from './style'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  text: {
    ...(screenOptions.headerBackTitleStyle as object),
  },
  icon: {},
  spacing: {
    marginLeft: Spacing.XS,
  },
})

interface StyleConfig {
  container?: ViewStyle
  text?: TextStyle
  icon?: TextStyle
}

type Config = {
  default?: StyleConfig
  pressed?: StyleConfig
  hovered?: StyleConfig
}

const config: Config = {
  default: StyleSheet.create({
    text: {
      color: screenOptions.headerTintColor,
    },
    icon: {
      color: screenOptions.headerTintColor,
    },
  }),
  pressed: StyleSheet.create({
    container: {
      opacity: 0.4,
    },
  }),
  /*eslint-disable react-native/no-unused-styles */
  hovered: StyleSheet.create({
    text: {
      color: Color.calmGrey,
    },
    icon: {
      color: Color.calmGrey,
    },
  }),
  /*eslint-enable react-native/no-unused-styles */
}

export interface Props extends PressableProps {
  title?: string
  icon?: Name
  iconSize?: IconSize | number
  color?: ColorValue
}
const NavButton = (props: PropsWithChildren<Props>) => {
  const { title, icon, iconSize, children, color, ...otherProps } = props

  const renderButton = (state: { pressed: boolean; hovered?: boolean }) => {
    const { pressed, hovered } = state

    const colorStyle = color && { color }

    const containerStyle = [
      styles.container,
      config.default?.container,
      pressed && config.pressed?.container,
      hovered && config.hovered?.container,
    ]
    const textStyle = [
      styles.text,
      icon && styles.spacing,
      config.default?.text,
      colorStyle,
      pressed && config.pressed?.text,
      hovered && config.hovered?.text,
    ]
    const iconStyle = [
      styles.icon,
      config.default?.icon,
      colorStyle,
      pressed && config.pressed?.icon,
      hovered && config.hovered?.icon,
    ]
    return (
      <View style={containerStyle}>
        {icon && <Icon name={icon} size={iconSize} style={iconStyle} />}
        {title && <Text style={textStyle}>{title}</Text>}
        {children}
      </View>
    )
  }

  return <Pressable {...otherProps}>{renderButton}</Pressable>
}

export default NavButton
